

import { DemoLoginPage } from './login.demo';
import { CloudLoginPage } from './login.cloud';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class LoginMobile extends mixin(environment.nexus, {
    box: CloudLoginPage,
    cloud: CloudLoginPage,
    demo: DemoLoginPage
}) { }
